// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__309iZ","vLegacy":"SelectSecondary_vLegacy__rLndr","error":"SelectSecondary_error__22ILq","disabled":"SelectSecondary_disabled__3-BsF"};